var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27602 0.782282C5.56947 0.187684 6.41735 0.187686 6.7108 0.782282L7.82253 3.03489L10.3084 3.39611C10.9646 3.49146 11.2266 4.29784 10.7518 4.76067L8.95299 6.51408L9.37763 8.98994C9.48972 9.64346 8.80377 10.1418 8.21687 9.83328L5.99341 8.66434L3.76995 9.83328C3.18305 10.1418 2.4971 9.64346 2.60919 8.98994L3.03383 6.51408L1.23502 4.76067C0.760205 4.29784 1.02221 3.49146 1.67839 3.39611L4.16429 3.03489L5.27602 0.782282Z",
    fill: "#DD296E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPink);
export default __webpack_public_path__ + "static/media/StarPink.2b5db0c0c2bade1db461f402dc251803.svg";
export { ForwardRef as ReactComponent };